import React, { useState,useRef, useEffect } from 'react';
import {Link,useNavigate} from 'react-router-dom' 
import N3rveLogo from './../../../images/N3rveLogo.png'
import PurpleBackIcon from './../../../images/purplebackicon.png'
import CheckCircle from './../../../images/checkcircle.png'
import carouselimageboundary from './../../../images/carouselimageboundary.png'
import carouselboundary from './../../../images/carouselboundry.png'
import NerveProCarouselImg from './../../../images/nerveproartistcarousel.png'
import NervousCarouselTick from './../../../images/nervouscarouseltick.png'
import NervePlusCarouselTick from './../../../images/nervepluscarouseltick.png'
import NervePremierCarouselTick from './../../../images/nerveprmiercarouseltick.png'
import InviteOnlyCarouselTick from './../../../images/inviteonlycarouseltick.png'
import carouselgridlines from './../../../images/carouselgridlines.png'
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import './N3rvePlan.css' 
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';


function N3rvePlan() {
    const [n3rvePlan,setN3rvePlan] = useState(0)
    const [dimensions, setDimensions] = useState({ 
      height: window.innerHeight,
      width: window.innerWidth
    })
    const {t, i18n } = useTranslation();
    const navigate = useNavigate();
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    
    function randomNumber(min, max) {
        return Math.random() * (max - min) + min;
    }

    const handleResize = () => {
      // console.log(window.innerWidth)
      setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
      });
    }

    useEffect(()=>{
        // setN3rvePlan(parseInt(randomNumber(1, 4))) 
        setN3rvePlan(parseInt(randomNumber(1, 4)))
        window.addEventListener("resize", handleResize, false);
        // setN3rvePlan(4)
    },[])

  return (
    <div>
       {/* ******************************************** */}


        {/* DESKTOP VIEW */}
        {
            dimensions.width >= 1024 &&
    <div className="PlanContainer" >
       <div className='N3rvePlanH1'>Here’s the best plan for you.</div>
      

       {
            n3rvePlan===1 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
               <img src={carouselboundary} style={{position:'absolute',width:'34.25em',height:'24.06em',left:'-13em',top:'-7em'}}/>
            <div style={{display:'flex',flexDirection:'column',paddingRight:'3.125em'}}>
                        <div className='CarouselPlanName' style={{color:'#EA4600'}}>{t('nervouscarouselheader')}</div>
                          
                          <div className='CarouselPlanDesc' style={{maxWidth:'18.29em'}}>
                          Kickstart your music career with the N3RVOUS plan, perfect for new and aspiring musicians. Enjoy essential tools and services to help you grow and succeed, all for free forever.
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    80% Revenue & 2 Tracks Release Annuaully:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Keep 80% of your earnings. Share your best work with up to 2 releases per year.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    35+ Platforms Distribution:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Reach a wide audience on platforms like Facebook, Instagram, and TikTok.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Basic Education:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access essential resources to learn and grow in the industry.
                                    </div>
                                  </div>
                          </div>
                          


              <div className='JoinUsBtn' onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
            <div style={{
                        backgroundImage:`url(${carouselimageboundary})`,
                        width:'29.06em',
                        height:'29.178em',
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'center',
                        marginTop:'-1em'
                      }}>
                         <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/kaqqa5wfqo2ifqkujiom"} style={{width:'26.56em',height:'26.62em'}}/>
                      </div>
           
          </div>
        }

        {
            n3rvePlan===2 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
              <img src={carouselboundary} style={{position:'absolute',width:'34.25em',height:'24.06em',left:'-13em',top:'-7em'}}/>
            <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',paddingRight:'3.125em'}}>
                <div className='CarouselPlanName' style={{color:'#D88AF3'}}>{t('nerveplusheader')}</div>
                <div className='CarouselPlanDesc' style={{maxWidth:'18.29em'}}>
                Elevate your music career with the N3RVE Plan, offering advanced tools and benefits for serious musicians. Enjoy everything from the N3RVOUS Free Plan plus exclusive features to maximize your growth and revenue.
                </div>
                
                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    100% Revenue & Unlimited Releases:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Keep all of your earnings. Release as many tracks as you want.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    150+ Platforms Distribution:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Reach a wider global audience on over 150 platforms 
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Advanced Analytics & Insights
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Gain deeper insights into your performance.
                                    </div>
                                  </div>
                          </div>
            

              <div className='JoinUsBtn' onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
            <div style={{
              backgroundImage:`url(${carouselimageboundary})`,
              width:'29.06em',
              height:'29.178em',
              display:'flex',
              alignItems:'center',
              justifyContent:'center',
              marginTop:'-1em'
            }}>
               <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/s3j2kwn48mkga220pp3t"} style={{width:'26.56em',height:'26.62em'}}/>
            </div>
           
          </div>
        }

        {
            n3rvePlan===3 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
               <img src={carouselboundary} style={{position:'absolute',width:'34.25em',height:'24.06em',left:'-13em',top:'-7em'}}/>
            <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',paddingRight:'3.125em'}}>
                        <div className='CarouselPlanName' style={{color:'#96FFF9'}}>{t('nerveproheader')}</div>
                          <div className='CarouselPlanDesc' style={{maxWidth:'18.29em'}}>
                          Expand your artistic horizons with the N3RVE Premier Plan, offering the ultimate tools and services for serious musicians looking to take their career to the next level.
                          </div>
                         
                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Exclusive Brand/Sync Deals:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access unique opportunities for brand partnerships and sync licensing.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Promotional Tools:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Utilize advanced tools to promote your music.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Playlist Submission: 
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Increase your reach by submitting your music to curated playlists.
                                    </div>
                                  </div>
                          </div>
                          

             
              <div className='JoinUsBtn' onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
            <div style={{
              backgroundImage:`url(${carouselimageboundary})`,
              width:'29.06em',
              height:'29.178em',
              display:'flex',
              alignItems:'center',
              justifyContent:'center',
              marginTop:'-1em'
            }}>
               <img src={NerveProCarouselImg} style={{width:'26.56em',height:'26.62em'}}/>
            </div>
           
          </div>
        } 

         {
            n3rvePlan=== 4 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
            <img src={carouselboundary} style={{position:'absolute',width:'34.25em',height:'24.06em',left:'-13em',top:'-7em'}}/>
            <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',paddingRight:'3.125em'}}>
            <div className='CarouselPlanName' style={{color:'#D4AD7F'}}>{t('inviteonlyheader')}</div>
                          <div className='CarouselPlanDesc'  style={{maxWidth:'18.29em'}}>Embrace the global rhythms with the N3XUS Plan, offering the ultimate suite of services for musicians ready to take their career worldwide. This plan includes all Premier benefits and adds exclusive features to maximize your reach and impact.</div>
                         

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={InviteOnlyCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Custom Distribution Strategy:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Tailor your music distribution to your unique needs.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={InviteOnlyCarouselTick}  style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Dedicated Customer Support:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Receive personalized support from our expert team.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={InviteOnlyCarouselTick}  style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Global Business Consulting:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access strategic advice to expand your global presence.
                                    </div>
                                  </div>
                          </div>

             

              <div className='JoinUsBtn' style={{marginTop:'0.4em'}} onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
            <div style={{
              backgroundImage:`url(${carouselimageboundary})`,
              width:'29.06em',
              height:'29.178em',
              display:'flex',
              alignItems:'center',
              justifyContent:'center',
              marginTop:'-1em'
            }}>
               <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pjkkztnp7ftqm5zgtrb4"} style={{width:'26.56em',height:'26.62em'}}/>
            </div>
           
          </div>
        }  
     
    </div>
    }



      {/* ******************************************** */}


        {/* TABLET VIEW */}
        {
             dimensions.width >= 768 && dimensions.width <1024 &&
    <div className="PlanContainer" >
       <div className='N3rvePlanH1'>Here’s the best plan for you.</div>
      

       {
            n3rvePlan===1 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
              
            <div style={{display:'flex',flexDirection:'column',paddingRight:'2.125em',paddingLeft:'1em'}}>
                        <div className='CarouselPlanName' style={{color:'#EA4600'}}>{t('nervouscarouselheader')}</div>
                          
                          <div className='CarouselPlanDesc' style={{maxWidth:'18.29em'}}>
                          Kickstart your music career with the N3RVOUS plan, perfect for new and aspiring musicians. Enjoy essential tools and services to help you grow and succeed, all for free forever.
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    80% Revenue & 2 Tracks Release Annuaully:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Keep 80% of your earnings. Share your best work with up to 2 releases per year.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    35+ Platforms Distribution:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Reach a wide audience on platforms like Facebook, Instagram, and TikTok.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Basic Education:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access essential resources to learn and grow in the industry.
                                    </div>
                                  </div>
                          </div>
                          


              <div className='JoinUsBtn' onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
          
            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/kaqqa5wfqo2ifqkujiom"} style={{width:'20.56em',height:'26.62em', borderRadius:'8px',paddingRight:'1em',alignSelf:'center'}}/>
                     
           
          </div>
        }

        {
            n3rvePlan===2 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
            
            <div  style={{display:'flex',flexDirection:'column',paddingRight:'2.125em',paddingLeft:'1em'}}>
                <div className='CarouselPlanName' style={{color:'#D88AF3'}}>{t('nerveplusheader')}</div>
                <div className='CarouselPlanDesc' style={{maxWidth:'18.29em'}}>
                Elevate your music career with the N3RVE Plan, offering advanced tools and benefits for serious musicians. Enjoy everything from the N3RVOUS Free Plan plus exclusive features to maximize your growth and revenue.
                </div>
                
                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    100% Revenue & Unlimited Releases:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Keep all of your earnings. Release as many tracks as you want.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    150+ Platforms Distribution:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Reach a wider global audience on over 150 platforms 
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Advanced Analytics & Insights
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Gain deeper insights into your performance.
                                    </div>
                                  </div>
                          </div>
            

              <div className='JoinUsBtn' onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
           
            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/s3j2kwn48mkga220pp3t"} style={{width:'20.56em',height:'26.62em', borderRadius:'8px',paddingRight:'1em',alignSelf:'center'}}/>
           
           
          </div>
        }

        {
            n3rvePlan===3 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
               
            <div style={{display:'flex',flexDirection:'column',paddingRight:'2.125em',paddingLeft:'1em'}}>
                        <div className='CarouselPlanName' style={{color:'#96FFF9'}}>{t('nerveproheader')}</div>
                          <div className='CarouselPlanDesc' style={{maxWidth:'18.29em'}}>
                          Expand your artistic horizons with the N3RVE Premier Plan, offering the ultimate tools and services for serious musicians looking to take their career to the next level.
                          </div>
                         
                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Exclusive Brand/Sync Deals:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access unique opportunities for brand partnerships and sync licensing.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Promotional Tools:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Utilize advanced tools to promote your music.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Playlist Submission: 
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Increase your reach by submitting your music to curated playlists.
                                    </div>
                                  </div>
                          </div>
                          

             
              <div className='JoinUsBtn' onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
           
            <img src={NerveProCarouselImg} style={{width:'20.56em',height:'26.62em', borderRadius:'8px',paddingRight:'1em',alignSelf:'center'}}/>
           
           
          </div>
        } 

         {
            n3rvePlan=== 4 &&
            <div style={{display:'flex',flexDirection:'row',position:'relative',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'3.8em',marginRight:'0em'}}>
          
            <div style={{display:'flex',flexDirection:'column',paddingRight:'2.125em',paddingLeft:'1em'}}>
            <div className='CarouselPlanName' style={{color:'#D4AD7F'}}>{t('inviteonlyheader')}</div>
                          <div className='CarouselPlanDesc'  style={{maxWidth:'18.29em'}}>Embrace the global rhythms with the N3XUS Plan, offering the ultimate suite of services for musicians ready to take their career worldwide. This plan includes all Premier benefits and adds exclusive features to maximize your reach and impact.</div>
                         

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={InviteOnlyCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Custom Distribution Strategy:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Tailor your music distribution to your unique needs.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={InviteOnlyCarouselTick}  style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Dedicated Customer Support:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Receive personalized support from our expert team.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em'}}>
                                  <img src={InviteOnlyCarouselTick}  style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Global Business Consulting:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access strategic advice to expand your global presence.
                                    </div>
                                  </div>
                          </div>

             

              <div className='JoinUsBtn' style={{marginTop:'0.4em'}} onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
           
            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pjkkztnp7ftqm5zgtrb4"} style={{width:'20.56em',height:'26.62em', borderRadius:'8px',paddingRight:'1em',alignSelf:'center'}}/>
          
           
          </div>
        }  
     
    </div>
    }




       {/* ******************************************** */}


        {/* MOBILE VIEW */}
        {
             dimensions.width < 768 &&
    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
       <div className='N3rvePlanH1' style={{fontSize:'2rem',marginLeft:'0.2em'}}>Here’s the best plan for you.</div>
      

       {
            n3rvePlan===1 &&
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',alignSelf:'center',marginRight:'0em',marginTop:'2em'}}>
               
              <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/kaqqa5wfqo2ifqkujiom"} style={{width:'80%',height:'18.62em',borderRadius:'5px',marginBottom:'1em'}}/>
                     

              <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                        <div className='CarouselPlanName' style={{color:'#EA4600'}}>{t('nervouscarouselheader')}</div>
                          
                          <div className='CarouselPlanDesc' style={{maxWidth:'80%'}}>
                          Kickstart your music career with the N3RVOUS plan, perfect for new and aspiring musicians. Enjoy essential tools and services to help you grow and succeed, all for free forever.
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    80% Revenue & 2 Tracks Release Annuaully:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Keep 80% of your earnings. Share your best work with up to 2 releases per year.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    35+ Platforms Distribution:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Reach a wide audience on platforms like Facebook, Instagram, and TikTok.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervousCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Basic Education:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access essential resources to learn and grow in the industry.
                                    </div>
                                  </div>
                          </div>
                          


              <div className='JoinUsBtn' style={{width:'80%'}} onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
         
           
          </div>
        }

        {
            n3rvePlan===2 &&
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',alignSelf:'center',marginRight:'0em',marginTop:'2em'}}>
             
             <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/s3j2kwn48mkga220pp3t"}  style={{width:'80%',height:'18.62em',borderRadius:'5px',marginBottom:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                <div className='CarouselPlanName' style={{color:'#D88AF3'}}>{t('nerveplusheader')}</div>
                <div className='CarouselPlanDesc'  style={{maxWidth:'80%'}}>
                Elevate your music career with the N3RVE Plan, offering advanced tools and benefits for serious musicians. Enjoy everything from the N3RVOUS Free Plan plus exclusive features to maximize your growth and revenue.
                </div>
                
                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    100% Revenue & Unlimited Releases:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Keep all of your earnings. Release as many tracks as you want.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    150+ Platforms Distribution:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Reach a wider global audience on over 150 platforms 
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervePlusCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Advanced Analytics & Insights
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Gain deeper insights into your performance.
                                    </div>
                                  </div>
                          </div>
            

              <div className='JoinUsBtn'  style={{width:'80%'}} onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
            
           
               
            
           
          </div>
        }

        {
            n3rvePlan===3 &&
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',alignSelf:'center',marginRight:'0em',marginTop:'2em'}}>
            <img src={NerveProCarouselImg} style={{width:'80%',height:'18.62em',borderRadius:'5px',marginBottom:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                        <div className='CarouselPlanName' style={{color:'#96FFF9'}}>{t('nerveproheader')}</div>
                          <div className='CarouselPlanDesc' style={{maxWidth:'80%'}}>
                          Expand your artistic horizons with the N3RVE Premier Plan, offering the ultimate tools and services for serious musicians looking to take their career to the next level.
                          </div>
                         
                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Exclusive Brand/Sync Deals:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access unique opportunities for brand partnerships and sync licensing.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Promotional Tools:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Utilize advanced tools to promote your music.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={NervePremierCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Playlist Submission: 
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Increase your reach by submitting your music to curated playlists.
                                    </div>
                                  </div>
                          </div>
                          

             
              <div className='JoinUsBtn' style={{width:'80%'}} onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
          
           
          </div>
        } 

         {
            n3rvePlan=== 4 &&
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',alignSelf:'center',marginRight:'0em',marginTop:'2em'}}>

            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pjkkztnp7ftqm5zgtrb4"} style={{width:'80%',height:'18.62em',borderRadius:'5px',marginBottom:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
            <div className='CarouselPlanName' style={{color:'#D4AD7F'}}>{t('inviteonlyheader')}</div>

                          <div className='CarouselPlanDesc'  style={{maxWidth:'80%'}}>Embrace the global rhythms with the N3XUS Plan, offering the ultimate suite of services for musicians ready to take their career worldwide. This plan includes all Premier benefits and adds exclusive features to maximize your reach and impact.</div>
                         

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={InviteOnlyCarouselTick} style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Custom Distribution Strategy:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Tailor your music distribution to your unique needs.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={InviteOnlyCarouselTick}  style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Dedicated Customer Support:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Receive personalized support from our expert team.
                                    </div>
                                  </div>
                          </div>

                          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',marginBottom:'0.5em',width:'90%'}}>
                                  <img src={InviteOnlyCarouselTick}  style={{width:'1.5em',height:'1.5em',marginRight:'0.625em'}}/>
                                  <div style={{display:'flex',flexDirection:'column',maxWidth:'25.56em'}}>
                                    <div className='CarouselPointHeader'>
                                    Global Business Consulting:
                                    </div>
                                    <div className='CarouselPointDesc'>
                                    Access strategic advice to expand your global presence.
                                    </div>
                                  </div>
                          </div>

             

              <div className='JoinUsBtn' style={{width:'80%'}} onClick={()=>navigate("/Signup")}>
                  JOIN US
                  <div className="HoverOverlay" />
              </div>
            </div>
     
          </div>
        }  
     
    </div>
    }

    </div>
  );
}

export default N3rvePlan;